import type { Client } from '../../models/client/client.model';

export interface HasClient {
  client(): Client | null;
}

/**
 * Wait for client to be ready by polling the ClientStore.
 * @param clientStore
 * @param timeoutMs
 * @param intervalMs
 * @returns
 */
export async function awaitClientReady(
  clientStore: HasClient,
  timeoutMs = 2000,
  intervalMs = 40
): Promise<Client | null> {
  const start = performance.now();

  let client = clientStore.client();

  while (!client && performance.now() - start < timeoutMs) {
    await new Promise((r) => setTimeout(r, intervalMs));
    client = clientStore.client();
  }

  return client ?? null;
}
